// ETHRAEON DemoLoading + DemoEmpty + DemoError · Phase S
// Verbatim per the KAIROS surface system spec.

import { IconDIM, IconEthraeonTrinity, IconRecursiveWitness } from "./icons";

export function DemoLoading({ message = "Preparing a clear view..." }: { message?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-neutral-600 dark:text-neutral-300">
      <IconRecursiveWitness className="w-6 h-6 mb-3 animate-spin-slow" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

export function DemoEmpty({ message = "This space is open for exploration." }: { message?: string }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-neutral-300 dark:border-neutral-700 py-10 text-neutral-500 dark:text-neutral-400">
      <IconDIM className="w-6 h-6 opacity-30 mb-3" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

export function DemoError({
  message = "Something did not align. Try again gently.",
  onRetry,
}: {
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-10 border border-neutral-300 dark:border-neutral-700 rounded-lg bg-neutral-50 dark:bg-neutral-900 text-neutral-600 dark:text-neutral-300">
      <IconEthraeonTrinity className="w-6 h-6 mb-3 opacity-70" />
      <p className="text-sm mb-3 text-center">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="text-xs px-3 py-1 rounded-full border border-neutral-300 dark:border-neutral-700 hover:bg-white dark:hover:bg-neutral-800"
        >
          Retry
        </button>
      )}
    </div>
  );
}
